<div class="filter-bar ignore-last">
    <section class="filters" [formGroup]="filterGroup">
        <eaglei-date-range
            [start]="startDate"
            [end]="endDate"
            [min]="ongService.minDate"
            [max]="maxDate"
            (change)="updateDateRange($event)">
        </eaglei-date-range>

        <mat-form-field class="filter-select" [class.active]="!!unitFilter">
            <mat-label>Unit Outages</mat-label>
            <mat-select [(value)]="unitFilter" formControlName="unitFilter">
                <mat-option value="all"> All Outages </mat-option>
                <mat-option value="both"> Alerts and Planned Outages </mat-option>
                <mat-option value="alert"> Alerts </mat-option>
                <mat-option value="planned"> Planned Outages </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="filter-select" [class.active]="!!processingClassFilter">
            <mat-label>Unit Processing Class</mat-label>
            <mat-select [(value)]="processingClassFilter" formControlName="processingFilter">
                <mat-option value="all"> All Processing Classes </mat-option>
                <mat-option value="Light Products"> Light Products </mat-option>
                <mat-option value="Heavy Products"> Heavy Products </mat-option>
                <mat-option value="Infrastructure"> Infrastructure </mat-option>
                <mat-option value="Primary Processing"> Primary Processing </mat-option>
                <mat-option value="Middle Distillates"> Middle Distillates </mat-option>
                <mat-option value="Primary Bitumen Processing"> Primary Bitumen Processing </mat-option>
                <mat-option value="Bitumen Secondary Refining"> Bitumen Secondary Refining </mat-option>
            </mat-select>
        </mat-form-field>
    </section>
</div>

<ng-container *ngTemplateOutlet="isRegion() ? regionLevel : refineryLevel"></ng-container>

<ng-template #regionLevel>
    <!-- Report Layout -->
    <div class="report-data">
        <ng-container [ngTemplateOutlet]="map"></ng-container>
        <ng-container [ngTemplateOutlet]="table"></ng-container>
    </div>

    <!-- Map -->
    <ng-template #map>
        <div class="map-section">
            <mat-card class="map">
                <mat-card-content>
                    <eaglei-leaflet-map [mapOptions]="mapOptions"></eaglei-leaflet-map>

                    <!-- Legend -->
                    <mat-card class="legend">
                        <mat-card-content>
                            <div class="legend-header-container">
                                <span class="legend-header">Legend</span>
                            </div>
                            <div class="divider"></div>
                            <div class="status">
                                <div class="icon-row">
                                    <div class="online-status">
                                        <mat-icon class="ph-fill ph-check-fat refinery-status-icon online"></mat-icon>
                                    </div>
                                    <span>Online</span>
                                </div>
                                <div class="icon-row">
                                    <div class="reduced-status">
                                        <mat-icon class="ph-fill ph-warning refinery-status-icon impacted"></mat-icon>
                                    </div>
                                    <span>Reduced Capacity</span>
                                </div>
                                <div class="icon-row">
                                    <div class="idle-status">
                                        <mat-icon class="ph-fill ph-prohibit refinery-status-icon offline"></mat-icon>
                                    </div>
                                    <span>Idled</span>
                                </div>

                                <div class="icon-row added-status">
                                    <div class="idle-status">
                                        <div class="planned-icon legend-status"></div>
                                    </div>
                                    <span>Planned Outages</span>
                                </div>
                                <div class="icon-row added-status">
                                    <div class="idle-status">
                                        <div class="alert-icon legend-status"></div>
                                    </div>
                                    <span>Alerts</span>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </mat-card-content>
            </mat-card>
        </div>
    </ng-template>
</ng-template>

<ng-template #refineryLevel>
    <!-- Report Layout -->
    <div class="report-data">
        <div class="level-header">
            <div class="icon-row">
                <fa-icon icon="arrow-left" (click)="returnToRegions()" class="clickable"></fa-icon>
                <span>Back to PADD Regions</span>
            </div>

            <div class="region-header">{{ selectedRegion.padd_region }}</div>

            <section class="filters" [formGroup]="filterGroup">
                <mat-form-field class="name-search-field" floatLabel="always">
                    <mat-label>Search Refinery Name</mat-label>
                    <!--suppress TypeScriptUnresolvedVariable -->
                    <input matInput placeholder="Refinery Name" formControlName="nameSearch" />
                </mat-form-field>
            </section>
        </div>

        <ng-container [ngTemplateOutlet]="chart"></ng-container>
        <ng-container [ngTemplateOutlet]="table"></ng-container>
    </div>

    <!-- Chart -->
    <ng-template #chart>
        <mat-card class="chart">
            <mat-card-content>
                <div class="chart-target">
                    <div #chartTarget class="chart-target"></div>
                </div>
            </mat-card-content>

            <div class="auto-mask hide-mask" *ngIf="selectedRefinery === undefined">
                <span class="mask-message">Select a Refinery to display units</span>
            </div>
        </mat-card>
    </ng-template>
</ng-template>

<!-- Table -->
<ng-template #table>
    <mat-card class="table-card">
        <mat-card-content>
            <div class="table-container">
                <table mat-table [dataSource]="dataSource" matSort [matSortDisableClear]="true">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Name
                            <eaglei-table-sort-header [columnName]="'name'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="padd">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            PADD Region
                            <eaglei-table-sort-header [columnName]="'padd'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">
                            <div class="icon-row">
                                <div class="region-icon" [style]="getRegionColor(info)"></div>
                                {{ info.padd_region }}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="lastYearChange">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            <div class="table-fit">
                                Last Year's Capacity Change
                                <span class="sub-header-text">(During Selected Date Range)</span>
                            </div>
                            <eaglei-table-sort-header [columnName]="'lastYearChange'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ (info.pcnt_change_in_capacity_minus_1_yr / 100)| percent : '1.1-2'}}</td>
                    </ng-container>

                    <ng-container matColumnDef="capacityChange">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            <div class="table-fit">
                                This Year's Capacity Change
                                <span class="sub-header-text">(During Selected Date Range)</span>
                            </div>
                            <eaglei-table-sort-header [columnName]="'capacityChange'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ (info.pcnt_change_in_capacity / 100) | percent : '1.1-2' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="impacted">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Impacted Capacity at End Date (bpd)
                            <eaglei-table-sort-header [columnName]="'impacted'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.impacted_capacity_at_end_date | eagleiNumber }}</td>
                    </ng-container>

                    <ng-container matColumnDef="totalCapacity">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Total Capacity (bpd)
                            <eaglei-table-sort-header [columnName]="'totalCapacity'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.capacity_at_end_date | eagleiNumber }}</td>
                    </ng-container>

                    <ng-container matColumnDef="impactedRef">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Impacted Capacity (bpd)
                            <eaglei-table-sort-header [columnName]="'impactedRef'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.impacted_capacity_at_end_date | eagleiNumber }}</td>
                    </ng-container>

                    <ng-container matColumnDef="totalCapacityRef">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Total Capacity (bpd)
                            <eaglei-table-sort-header [columnName]="'totalCapacityRef'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.capacity_at_end_date | eagleiNumber }}</td>
                    </ng-container>

                    <ng-container matColumnDef="alerts">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Total Alerts
                            <eaglei-table-sort-header [columnName]="'alerts'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">
                            <div class="icon-row">
                                <div class="alert-icon clickable" (click)="openInfoModal($event, 'alert', info)"></div>
                                {{ info.refinery_alert_count }}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="plannedOutages">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Total Planned Outages
                            <eaglei-table-sort-header [columnName]="'plannedOutages'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">
                            <div class="icon-row">
                                <div class="planned-icon clickable" (click)="openInfoModal($event, 'planned', info)"></div>
                                {{ info.planned_outage_count }}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3"></th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">
                            <button mat-flat-button color="primary" (click)="viewRegion(info)">View Region</button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totalUnits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Total Units
                            <eaglei-table-sort-header [columnName]="'totalUnits'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.total_units }}</td>
                    </ng-container>

                    <ng-container matColumnDef="online">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Online Units
                            <eaglei-table-sort-header [columnName]="'online'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.units_online }}</td>
                    </ng-container>

                    <ng-container matColumnDef="offline">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
                            Offline Units
                            <eaglei-table-sort-header [columnName]="'offline'" [sort]="sort"></eaglei-table-sort-header>
                        </th>
                        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.units_offline }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnNames()"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: columnNames(); let odd = odd"
                        class="clickable"
                        [class.selected]="selectedRefinery === row"
                        (click)="toggleSelectedRow(row)"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[25, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- Export Menu -->
<mat-menu #menu="matMenu" overlapTrigger>
    <button (click)="exportTable()" mat-menu-item>Export Table As CSV</button>
</mat-menu>
